export default __webpack_public_path__ + "static/4-2088c0385b8dbfcf80a3bfbb8e24cd95.png";